import React from 'react'
import PropTypes from 'prop-types'
import { ButtonSecondary, IconAgent } from 'mage-deps/@klarna/bubble-ui'
import { hooks as i18nHooks } from 'mage-i18n'
import { useEducationAnalytics } from 'education-tools'
import { useHelpContext } from './hooks'

ContactButton.propTypes = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  analyticsCategory: PropTypes.string.isRequired
}

export default function ContactButton({ articleId, articleTitle, analyticsCategory }) {
  const t = i18nHooks.useTranslator()
  const { navigation } = useHelpContext()

  const track = useEducationAnalytics({
    category: analyticsCategory,
    action: 'click',
    label: articleTitle,
    referenceId: articleId,
    referenceType: articleId ? 'article' : undefined
  })

  return (
    <ButtonSecondary id="uhqm-contact-button" size="medium" icon={IconAgent} onClick={onClick}>
      {t('hqm.moreHelp.contactButton', {}, 'Contact us')}
    </ButtonSecondary>
  )

  function onClick() {
    track()
    navigation.push('contact', { articleId, articleTitle })
  }
}
